<template>
  <component :is="tag" class="badge"><slot /></component>
</template>

<script>
export default {
  name: "Badge",
  props: {
    tag: {
      type: String,
      default: "span",
    },
  },
};
</script>

<style lang="scss" scoped>
.badge {
  background-color: #f2f2f2;
  font-size: 12px;
  border-radius: 4px;
  color: #6c717f;
  padding: 4px 8px;
  display: inline-block;
  outline: none;
  border: none;
  cursor: pointer;
}
</style>
